import { RhinoError } from '@kaltura-ott/tvpil-shared';

import { useHandleRhinoError } from './useHandleRhinoError';
import { useHandleRhinoRefetch } from './useHandleRhinoRefetch';

export function useRhinoErrorReaction({
  error,
  refetch,
  isFetchEpgPrograms = false,
}: {
  error: Error | RhinoError | undefined | null;
  refetch: () => Promise<void>;
  isFetchEpgPrograms?: boolean;
}) {
  const handleRefetch = useHandleRhinoRefetch(refetch);

  useHandleRhinoError({ error: error as RhinoError, refetch: handleRefetch, isFetchEpgPrograms });
}
